/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as Shared from './trans-website-booking-myprofile-bookingdetailsview-shared';
export * as TicketOverview from './trans-website-booking-myprofile-bookingdetailsview-ticketoverview';
export * as DetailsTable from './trans-website-booking-myprofile-bookingdetailsview-detailstable';
export * as FutureBooking from './trans-website-booking-myprofile-bookingdetailsview-futurebooking';
export * as PreviousBooking from './trans-website-booking-myprofile-bookingdetailsview-previousbooking';

export const SpacesBooked = 'Website.Booking.MyProfile.BookingDetailsView.SpacesBooked';
export const SpacesBooked_one = 'Website.Booking.MyProfile.BookingDetailsView.SpacesBooked_one';
export const TicketsQuantity = 'Website.Booking.MyProfile.BookingDetailsView.TicketsQuantity';
export const OpenTicketDrawer = 'Website.Booking.MyProfile.BookingDetailsView.OpenTicketDrawer';
export const DownloadTicketsPDF = 'Website.Booking.MyProfile.BookingDetailsView.DownloadTicketsPDF';
export const AppVirtualDisabledDisclaimer = 'Website.Booking.MyProfile.BookingDetailsView.AppVirtualDisabledDisclaimer';
export const ProductRecommendationsHeadline = 'Website.Booking.MyProfile.BookingDetailsView.ProductRecommendationsHeadline';
export const CallSummaryNoteHeadline = 'Website.Booking.MyProfile.BookingDetailsView.CallSummaryNoteHeadline';
